export enum Tunic {
  Green,
  Blue,
  Red
}
